import type {
	CancelListingStruckSuggestedPlayerInput,
	CancelMultipleListingStruckSuggestedPlayerInput,
	deleteSuggestedPlayerInput,
	getAllSuggestedPlayersInput,
	getSuggestedPlayerInput,
	getSuggestedPlayersFacetsInput,
	updateSuggestedPlayerInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllSuggestedPlayers: getAllSuggestedPlayersInput;

	useGetSuggestedPlayer: getSuggestedPlayerInput;
	useGetSuggestedPlayersFacets: getSuggestedPlayersFacetsInput;
	useUpdateSuggestedPlayer: updateSuggestedPlayerInput;
	useDeleteSuggestedPlayer: deleteSuggestedPlayerInput;
	useCancelListingStruckSuggestedPlayer: CancelListingStruckSuggestedPlayerInput;
	useCancelMultipleListingStruckSuggestedPlayers: CancelMultipleListingStruckSuggestedPlayerInput;
}

const SUGGESTED_PLAYERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"suggested-players",
	[
		"useGetAllSuggestedPlayers",
		"useGetSuggestedPlayer",
		"useGetSuggestedPlayersFacets",
		"useUpdateSuggestedPlayer",
		"useDeleteSuggestedPlayer",
		"useCancelListingStruckSuggestedPlayer",
		"useCancelMultipleListingStruckSuggestedPlayers",
	],
);

export { SUGGESTED_PLAYERS_SERVICE_KEYS };
